<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">GGSN Subscriber Lookup</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-container>
			<b-card no-body>
				<b-card-header>
				<b-form @submit="getData($event)">
					<b-row class="justify-content-center">
						<b-col cols="auto">
							<label for="imsi" class="font-weight-900 text-sm">IMSI</label>
						</b-col>
						<b-col cols="4">
							<b-form-input
								id="imsi"
								v-model="imsi"
								placeholder="IMSI Number Only"
								type="number"
								:state="imsiState"
								size="sm"
								disabled-field="notEnabled"
							>
							</b-form-input>
							<b-form-invalid-feedback>
								Please enter a valid IMSI
							</b-form-invalid-feedback>
						</b-col>
						<b-col cols="auto">
							<label for="apn-select" class="font-weight-600 text-sm pr-2">APN to Lookup</label>
						</b-col>
						<b-col cols="4">
							<b-form-select
									id="apn-select"
									v-model="apnType"
									:options="apnTypeOptions"
									selected="all"
									value-field="type"
									text-field="value"
									size="sm"
									disabled-field="notEnabled"
								>
							</b-form-select>
						</b-col>
						<b-col cols="auto">
							<b-button variant="primary" size="sm" type="submit" :disabled="loadingStatus || imsiState === false">
								Search <i class="fa fa-search"></i>
							</b-button>
						</b-col>
					</b-row>
				</b-form>
			</b-card-header>
				<b-card-body class="p-3">
					<div class="text-center w-100" v-if="loadingStatus">
						<b-icon icon="three-dots" class="text-center" animation="cylon" font-scale="4"></b-icon>
					</div>
					<div class="primary-table" v-if="!loadingStatus">
						<b-table
						:fields="fields"
						:items="items"
						:current-page="currentPage"
						:per-page="perPage"
						:filter="filter"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						:sort-direction.sync="sortDirection"
						:sort-direction="sortDirection"
						class="text-center custom-table"
						hover
						responsive
						show-empty
						small
						striped
						>
						</b-table>
					</div>
					<b-row class="mt-4" v-if="items.length>0">
						<b-col>
							Showing {{ startPage() }} - {{ lastPage() }} of {{ totalRows }} entries
						</b-col>
						<b-col xl="auto" md="auto" sm="auto ">
							<b-pagination
								class="flex-fill-custom pr-4"
								v-model="currentPage"
								:total-rows="totalRows"
								:per-page="perPage"
								size="sm"
							></b-pagination>
						</b-col>
					</b-row>
				</b-card-body>
			</b-card>
		</b-container>
	</div>
</template>

<script>
import initService from "../../../common/api-services/init-service";
import troubleshootingService from "../../../common/api-services/troubleshooting-service";
import handleResponse from "../../../common/directive/handlResponse";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb.vue";
import pagination from '../../../common/format/pagination';

export default {
	name: "GgsnSubscriberLookup",
	components: {
		RouteBreadCrumb,
	},
	data() {
		return {
			items: [],
			fields: [
				{key: "access", label: "Access", sortable: true, sortDirection: "desc"},
				{key: "callid", label: "Call ID", sortable: true, sortDirection: "desc"},
				{key: "msid", label: "MSID", sortable: true, sortDirection: "desc"},
				{key: "username", label: "Username", sortable: true, sortDirection: "desc"},
				{key: "ip", label: "IP", sortable: true, sortDirection: "desc"},
				{key: "time-idle", label: "Time Idle", sortable: true, sortDirection: "desc"},
			],
			apnTypeOptions: [
				{type: "all", value: "All APNs"},
				{type: "internet.wightman", value: "internet.wightman"},
				{type: "wap.wightman", value: "wap.wightman"},
				{type: "ims.wightman", value: "ims.wightman"},
				{type: "mns.wightman", value: "mns.wightman"},
			],
			apnType: "all",
			imsi: "",
			currentPage: 1,
			perPage: 20,
			pageOptions: [10, 25, 50, 100],
			fromPage: 0,
			totalRows: 0,
			loadingStatus: false,
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
		};
	},
	computed: {
		imsiState() {
			if (this.imsi.length === 0) return null;
			else if (this.imsi.length >= 15) return true;
			else return false;
		},
	},
	mounted() {
		document.title = "Troubleshooting - GGSN Subscriber Lookup";
		this.noAccess =
			!initService.getUserRoles().includes("Administrator") &&
			!initService.getUserRoles().includes("CARRIER_ADMIN") &&
			!initService.getUserRoles().includes("PORTAL_ADMIN ");

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/home");
		}
		// this.getApnTypes();
	},
	methods: {
		async getData(event) {
			event.preventDefault();
			this.items = [];
			this.totalRows = 0;
			this.currentPage = 1;
			this.loadingStatus = true;
			await troubleshootingService
				.getGgsnSubscriber(this.apnType, this.imsi)
				.then(response => {
					// console.log("GGSN Lookup response", response);
					if (response.message && String(response.message).toLocaleLowerCase().includes("fail")) {
						this.loadingStatus = false;
						if (response.message.hasOwnProperty("details")) {
							//this.$toast.error(`ERROR: ${response.message.details}`);
						} else if (response.message.hasOwnProperty("error")) {
							//this.$toast.error(response.message.error);
						} else {
							//this.$toast.error(response.message);
						}
						if (response.message.hasOwnProperty("details")) {
							//this.$toast.error(`ERROR: ${response.message.details}`);
						} else if (response.message.hasOwnProperty("error")) {
							//this.$toast.error(response.message.error);
						} else {
							//this.$toast.error(response.message);
						}
					} else {
						this.items = response.message.results;
						this.totalRows = response.message.total.count;
						this.loadingStatus = false;
					}
					this.getTotalRows();
				})
				.catch(error => {
					console.log("error", error);
					this.loadingStatus = false;
					this.items = [];
					// let {type, msg} = handleResponse.apiResponse(error);
					// this.$toast(msg, {type: type});
				});
		},

		async getApnTypes() {
			await troubleshootingService
				.getApnTypes()
				.then(response => {
					console.log("getApnTypes response", response);
					if ( response.message
					&& String(response.message).toLowerCase().includes("fail")
					|| String(response.message).toLowerCase().includes("error")
					|| String(response.message).toLowerCase().includes("null") ) {
						if (response.message.hasOwnProperty("details")) {
							this.$toast.error(`ERROR: ${response.message.details}`);
						} else if (response.message.hasOwnProperty("error")) {
							this.$toast.error(response.message.error);
						} else {
							this.$toast.error(response.message);
						}
					} else {
						this.apnTypeOptions = response.message;
					}
				})
				.catch(error => {
					console.log("error", error);
					this.items = [];
					let {type, msg} = handleResponse.apiResponse(error);
					this.$toast(msg, {type: type});
				});
		},
		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		},
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},
	},
};
</script>
<style scoped>
.scrollable {
	height: 50vh;
	overflow-y: scroll;
}
</style>
